import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector }   from "react-redux";
import { Button, Icon, Label, Popup } from "semantic-ui-react";
import SendMail                       from "../../../application/usecase/mail/send/SendMail";
import AccountOptionType                  from "../../../domain/account/AccountOptionType";
import AccountOptionTypes                 from "../../../domain/account/AccountOptionTypes";
import MailSend                           from "../../../domain/mail/send/MailSend";
import MailSendRepository                 from "../../../domain/mail/send/MailSendRepository";
import { ResKaState }                     from "../../../index";
import MailSendDataSource                 from "../../../infrastructure/datasource/mail/send/MailSendDataSource";
import BottomSection                      from "../common/layout/BottomSection";

const MailSendButton: FC = () => {
  const [count, setCount] = useState(0);
  const mailSend: MailSend = useSelector((state: ResKaState) => state.mailSend);
  const optionTypes: AccountOptionTypes = useSelector((state: ResKaState) => state.account.options);
  const sendMail: SendMail = new SendMail(useDispatch());
  const repository: MailSendRepository = new MailSendDataSource(useDispatch());

  const limit = (optionTypes: AccountOptionTypes): number => {
    switch (optionTypes.getMailSendOption()) {
      default:
        return 0;
      case AccountOptionType.EMAIL_SEND_LIMIT_500:
        return 500;
      case AccountOptionType.EMAIL_SEND_LIMIT_1000:
        return 1000;
      case AccountOptionType.EMAIL_SEND_LIMIT_UNLIMITED:
        return NaN;
    }
  };

  const getCount = () => {
    repository.getCount().then(response => setCount(response.data.count))
  };

  useEffect(() => getCount(), []);

  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ async () => {
          await sendMail.execute(mailSend);
          getCount();
        } }
      >
        <Icon name="send"/>
        メールを送信する
      </Button>
      {
        isNaN(limit(optionTypes))
          ? <></>
          : (
            <>
              <BottomSection>
                <Label>
                  月間メール送信数
                  <Label.Detail>
                    { count }/{ limit(optionTypes) }
                  </Label.Detail>
                </Label>
                <Popup
                  trigger={ <Icon name="help circle" style={ {marginLeft: "0.5rem"} }/> }
                >
                  「月のメール送信数／月のメール送信上限数」<br/>
                  送信上限数以上のメール送信はできません。
                </Popup>
              </BottomSection>
            </>
          )
      }
    </>
  );
};

export default MailSendButton;
